import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { getAIResponse } from '../../services/aiService';
import { supabase } from '../../services/supabase';
import { fetchOverviewData } from '../../services/overview';
import './AIFloatingWidget.css';

function AIFloatingWidget() {
  const { landId, cropId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [response, setResponse] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [context, setContext] = useState(null);

  // Don't show on the main chat page to avoid double widgets
  if (location.pathname.includes('ai-chat')) return null;

  const handleQuickAsk = async (e) => {
    e.preventDefault();
    if (!message.trim() || !landId || !cropId) return;

    setIsLoading(true);
    setResponse('');
    
    try {
      // Fetch fresh context
      const { data: l } = await supabase.from('lands').select('*').eq('id', landId).single();
      const { data: c } = await supabase.from('crops').select('*').eq('id', cropId).single();
      const ov = await fetchOverviewData(landId, cropId);
      
      const res = await getAIResponse(message, { land: l, crop: c, overview: ov });
      if (res.success) {
        setResponse(res.text);
      } else {
        setResponse("آسف يا هندسة، حصل مشكلة في الاتصال. جرب تاني كمان شوية.");
      }
    } catch (err) {
      setResponse("فيه مشكلة في البيانات حالياً.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={`ai-widget-wrapper ${isOpen ? 'is-open' : ''}`}>
      <button className="ai-fab" onClick={() => setIsOpen(!isOpen)}>
        <span className="material-symbols-outlined">{isOpen ? 'close' : 'smart_toy'}</span>
        {!isOpen && <span className="ai-badge">اسألني</span>}
      </button>

      {isOpen && (
        <div className="ai-mini-panel">
          <div className="ai-panel-header">
            <span className="material-symbols-outlined">psychology</span>
            <div>
              <h4>باشمهندس ديوان</h4>
              <p>مستشارك الذكي وجاهز للتخطيط</p>
            </div>
          </div>

          <div className="ai-panel-body">
            {response ? (
              <div className="ai-response-bubble">
                {response}
                <button className="go-to-chat" onClick={() => navigate(`/dashboard/land/${landId}/crop/${cropId}/ai-chat`)}>
                  فتح الشات الكامل
                  <span className="material-symbols-outlined">open_in_new</span>
                </button>
              </div>
            ) : (
              <p className="ai-welcome">أهلاً بك يا هندسة! معاك بيانات الأرض والمحصول وجاهز أحسبلك أي خطة أو إضافة محتاجها. اسألني أي سؤال هنا..</p>
            )}
            
            {isLoading && (
              <div className="ai-loading-mini">
                <span className="dot"></span><span className="dot"></span><span className="dot"></span>
              </div>
            )}
          </div>

          <form className="ai-panel-footer" onSubmit={handleQuickAsk}>
            <input 
              type="text" 
              placeholder="مثال: إزاي أوفر في السماد دلوقتي؟" 
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              disabled={isLoading}
            />
            <button type="submit" disabled={isLoading || !message.trim()}>
              <span className="material-symbols-outlined">send</span>
            </button>
          </form>
        </div>
      )}
    </div>
  );
}

export default AIFloatingWidget;
